import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "ladder" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.steps, (step) => {
      return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["ladder-step", { isFilled: _ctx.value >= step }]),
        key: step
      }, null, 2))
    }), 128))
  ]))
}